// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.users-page {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
  min-height: 100vh;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 10px;
  color: white;
}

.page-header h1 {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  font-size: 2rem;
}

.add-user-form {
  background: rgba(15, 23, 42, 0.7);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 25px;
  margin-bottom: 30px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.add-user-form h2 {
  margin-top: 0;
  color: var(--white);
  margin-bottom: 20px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin-bottom: 20px;
}

.form-row input {
  padding: 10px 15px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  font-size: 1rem;
  transition: all 0.3s;
  background: rgba(15, 23, 42, 0.6);
  color: var(--white);
}

.form-row input::placeholder {
  color: rgba(226, 232, 240, 0.4);
}

.form-row input:focus {
  outline: none;
  border-color: var(--primary-light);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);
  background: rgba(15, 23, 42, 0.8);
}

.permissions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 10px;
  margin: 20px 0;
}

.permissions-grid h4 {
  grid-column: 1 / -1;
  margin: 0 0 10px 0;
  color: #ffffff;
}

.permission-checkbox {
  display: flex;
  align-items: center;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.permission-checkbox:hover:not(.disabled) {
  background: rgba(99, 102, 241, 0.15);
  border-color: rgba(99, 102, 241, 0.3);
}

.permission-checkbox.disabled {
  cursor: default;
  opacity: 0.7;
}

.permission-checkbox input[type="checkbox"] {
  margin-right: 8px;
  cursor: pointer;
}

.permission-checkbox.disabled input[type="checkbox"] {
  cursor: default;
}

.checkbox-label {
  -webkit-user-select: none;
          user-select: none;
  font-size: 0.95rem;
  color: #ffffff;
}

.form-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 20px;
}

.users-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 20px;
}

.user-card {
  background: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s, box-shadow 0.3s, border-color 0.3s;
}

.user-card:hover {
  box-shadow: 0 20px 60px rgba(99, 102, 241, 0.2);
  border-color: rgba(99, 102, 241, 0.4);
}

.user-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.user-info h3 {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--white);
}

.admin-icon {
  color: #fbbf24;
  font-size: 1.2rem;
}

.admin-badge {
  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
  color: white;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
}

.user-actions {
  display: flex;
  gap: 8px;
}

.btn-icon {
  padding: 8px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  background: transparent;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
}

.btn-icon.edit {
  color: #3b82f6;
}

.btn-icon.edit:hover {
  background: #dbeafe;
  transform: scale(1.1);
}

.btn-icon.delete {
  color: #ef4444;
}

.btn-icon.delete:hover {
  background: #fee2e2;
  transform: scale(1.1);
}

.btn-icon.save {
  color: #10b981;
}

.btn-icon.save:hover {
  background: #d1fae5;
  transform: scale(1.1);
}

.btn-icon.cancel {
  color: #6b7280;
}

.btn-icon.cancel:hover {
  background: #f3f4f6;
  transform: scale(1.1);
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn-success {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
}

.btn-success:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
  color: #ffffff;
}

.no-users {
  text-align: center;
  padding: 60px 20px;
  color: #ffffff;
}

.no-users svg {
  font-size: 4rem;
  margin-bottom: 20px;
}

.no-users p {
  font-size: 1.2rem;
  margin: 0;
}

.loading {
  text-align: center;
  padding: 60px;
  font-size: 1.2rem;
  color: #ffffff;
}

@media (max-width: 768px) {
  .form-row {
    grid-template-columns: 1fr;
  }

  .users-grid {
    grid-template-columns: 1fr;
  }

  .page-header {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }
}
/* Password button */
.btn-icon.password {
  color: #10b981;
}

.btn-icon.password:hover {
  background: #d1fae5;
  transform: scale(1.1);
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: rgba(15, 23, 42, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  padding: 30px;
  max-width: 450px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}

.modal-content h2 {
  margin-top: 0;
  margin-bottom: 20px;
  color: var(--white);
}

.modal-content p {
  margin-bottom: 20px;
  color: #ffffff;
}

.modal-content .form-group {
  margin-bottom: 20px;
}

.modal-content .form-group label {
  display: block;
  margin-bottom: 8px;
  color: #ffffff;
  font-weight: 500;
}

.modal-content .form-group input {
  width: 100%;
  padding: 10px 15px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  font-size: 1rem;
  background: rgba(15, 23, 42, 0.6);
  color: var(--white);
  transition: all 0.3s;
}

.modal-content .form-group input::placeholder {
  color: rgba(226, 232, 240, 0.4);
}

.modal-content .form-group input:focus {
  outline: none;
  border-color: var(--primary-light);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);
  background: rgba(15, 23, 42, 0.8);
}

.modal-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

/* ============ LIGHT THEME OVERRIDES ============ */
[data-theme="light"] .add-user-form h2 {
  color: #1e293b;
}

[data-theme="light"] .form-row input {
  background: rgba(255, 255, 255, 0.9);
  color: #1e293b;
  border: 1px solid rgba(15, 23, 42, 0.15);
}

[data-theme="light"] .form-row input::placeholder {
  color: rgba(30, 41, 59, 0.4);
}

[data-theme="light"] .form-row input:focus {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0 0 3px rgba(100, 116, 139, 0.2);
}

[data-theme="light"] .permissions-grid h4 {
  color: #1e293b;
}

[data-theme="light"] .checkbox-label {
  color: #1e293b;
}

[data-theme="light"] .permission-checkbox {
  background: rgba(15, 23, 42, 0.03);
  border: 1px solid rgba(15, 23, 42, 0.08);
}

[data-theme="light"] .permission-checkbox:hover:not(.disabled) {
  background: rgba(100, 116, 139, 0.1);
  border-color: rgba(100, 116, 139, 0.3);
}

[data-theme="light"] .user-card {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(15, 23, 42, 0.1);
}

[data-theme="light"] .user-card:hover {
  box-shadow: 0 20px 60px rgba(100, 116, 139, 0.15);
  border-color: rgba(100, 116, 139, 0.3);
}

[data-theme="light"] .user-header {
  border-bottom: 1px solid rgba(15, 23, 42, 0.1);
}

[data-theme="light"] .user-info h3 {
  color: #1e293b;
}

[data-theme="light"] .btn-secondary {
  background: rgba(100, 116, 139, 0.08);
  color: #1e293b;
  border: 1px solid rgba(100, 116, 139, 0.2);
}

[data-theme="light"] .btn-secondary:hover {
  background: rgba(100, 116, 139, 0.12);
  border-color: rgba(100, 116, 139, 0.3);
  color: #1e293b;
}

[data-theme="light"] .no-users {
  color: #475569;
}

[data-theme="light"] .loading {
  color: #475569;
}

[data-theme="light"] .modal-content {
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid rgba(15, 23, 42, 0.15);
}

[data-theme="light"] .modal-content h2 {
  color: #1e293b;
}

[data-theme="light"] .modal-content p {
  color: #475569;
}

[data-theme="light"] .modal-content .form-group label {
  color: #1e293b;
}

[data-theme="light"] .modal-content .form-group input {
  background: rgba(255, 255, 255, 0.9);
  color: #1e293b;
  border: 1px solid rgba(15, 23, 42, 0.15);
}

[data-theme="light"] .modal-content .form-group input::placeholder {
  color: rgba(30, 41, 59, 0.4);
}

[data-theme="light"] .modal-content .form-group input:focus {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0 0 3px rgba(100, 116, 139, 0.2);
}
`, "",{"version":3,"sources":["webpack://./src/features/users/Users.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;EAC7C,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,8DAA8D;AAChE;;AAEA;EACE,+CAA+C;EAC/C,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;AACF;AACA,oBAAoB;AACpB;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;EAC7C,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA,oDAAoD;AACpD;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,iDAAiD;EACjD,sCAAsC;AACxC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,8CAA8C;AAChD","sourcesContent":[".users-page {\n  padding: 20px;\n  max-width: 1400px;\n  margin: 0 auto;\n  min-height: 100vh;\n}\n\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  padding: 20px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 10px;\n  color: white;\n}\n\n.page-header h1 {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 0;\n  font-size: 2rem;\n}\n\n.add-user-form {\n  background: rgba(15, 23, 42, 0.7);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  padding: 25px;\n  margin-bottom: 30px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n}\n\n.add-user-form h2 {\n  margin-top: 0;\n  color: var(--white);\n  margin-bottom: 20px;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 15px;\n  margin-bottom: 20px;\n}\n\n.form-row input {\n  padding: 10px 15px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 12px;\n  font-size: 1rem;\n  transition: all 0.3s;\n  background: rgba(15, 23, 42, 0.6);\n  color: var(--white);\n}\n\n.form-row input::placeholder {\n  color: rgba(226, 232, 240, 0.4);\n}\n\n.form-row input:focus {\n  outline: none;\n  border-color: var(--primary-light);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);\n  background: rgba(15, 23, 42, 0.8);\n}\n\n.permissions-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  gap: 10px;\n  margin: 20px 0;\n}\n\n.permissions-grid h4 {\n  grid-column: 1 / -1;\n  margin: 0 0 10px 0;\n  color: #ffffff;\n}\n\n.permission-checkbox {\n  display: flex;\n  align-items: center;\n  padding: 8px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s;\n  background: rgba(255, 255, 255, 0.02);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.permission-checkbox:hover:not(.disabled) {\n  background: rgba(99, 102, 241, 0.15);\n  border-color: rgba(99, 102, 241, 0.3);\n}\n\n.permission-checkbox.disabled {\n  cursor: default;\n  opacity: 0.7;\n}\n\n.permission-checkbox input[type=\"checkbox\"] {\n  margin-right: 8px;\n  cursor: pointer;\n}\n\n.permission-checkbox.disabled input[type=\"checkbox\"] {\n  cursor: default;\n}\n\n.checkbox-label {\n  user-select: none;\n  font-size: 0.95rem;\n  color: #ffffff;\n}\n\n.form-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n.users-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));\n  gap: 20px;\n}\n\n.user-card {\n  background: rgba(15, 23, 42, 0.6);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 16px;\n  padding: 20px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  transition: transform 0.3s, box-shadow 0.3s, border-color 0.3s;\n}\n\n.user-card:hover {\n  box-shadow: 0 20px 60px rgba(99, 102, 241, 0.2);\n  border-color: rgba(99, 102, 241, 0.4);\n}\n\n.user-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 15px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.user-info h3 {\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--white);\n}\n\n.admin-icon {\n  color: #fbbf24;\n  font-size: 1.2rem;\n}\n\n.admin-badge {\n  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);\n  color: white;\n  padding: 3px 10px;\n  border-radius: 20px;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.user-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.btn-icon {\n  padding: 8px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  background: transparent;\n  transition: all 0.3s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n}\n\n.btn-icon.edit {\n  color: #3b82f6;\n}\n\n.btn-icon.edit:hover {\n  background: #dbeafe;\n  transform: scale(1.1);\n}\n\n.btn-icon.delete {\n  color: #ef4444;\n}\n\n.btn-icon.delete:hover {\n  background: #fee2e2;\n  transform: scale(1.1);\n}\n\n.btn-icon.save {\n  color: #10b981;\n}\n\n.btn-icon.save:hover {\n  background: #d1fae5;\n  transform: scale(1.1);\n}\n\n.btn-icon.cancel {\n  color: #6b7280;\n}\n\n.btn-icon.cancel:hover {\n  background: #f3f4f6;\n  transform: scale(1.1);\n}\n\n.btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.3s;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.btn-success {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n}\n\n.btn-success:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);\n}\n\n.btn-secondary {\n  background: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.btn-secondary:hover {\n  background: rgba(255, 255, 255, 0.15);\n  border-color: rgba(255, 255, 255, 0.3);\n  color: #ffffff;\n}\n\n.no-users {\n  text-align: center;\n  padding: 60px 20px;\n  color: #ffffff;\n}\n\n.no-users svg {\n  font-size: 4rem;\n  margin-bottom: 20px;\n}\n\n.no-users p {\n  font-size: 1.2rem;\n  margin: 0;\n}\n\n.loading {\n  text-align: center;\n  padding: 60px;\n  font-size: 1.2rem;\n  color: #ffffff;\n}\n\n@media (max-width: 768px) {\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n\n  .users-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .page-header {\n    flex-direction: column;\n    gap: 15px;\n    text-align: center;\n  }\n}\n/* Password button */\n.btn-icon.password {\n  color: #10b981;\n}\n\n.btn-icon.password:hover {\n  background: #d1fae5;\n  transform: scale(1.1);\n}\n\n/* Modal styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: rgba(15, 23, 42, 0.95);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 16px;\n  padding: 30px;\n  max-width: 450px;\n  width: 90%;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n}\n\n.modal-content h2 {\n  margin-top: 0;\n  margin-bottom: 20px;\n  color: var(--white);\n}\n\n.modal-content p {\n  margin-bottom: 20px;\n  color: #ffffff;\n}\n\n.modal-content .form-group {\n  margin-bottom: 20px;\n}\n\n.modal-content .form-group label {\n  display: block;\n  margin-bottom: 8px;\n  color: #ffffff;\n  font-weight: 500;\n}\n\n.modal-content .form-group input {\n  width: 100%;\n  padding: 10px 15px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 12px;\n  font-size: 1rem;\n  background: rgba(15, 23, 42, 0.6);\n  color: var(--white);\n  transition: all 0.3s;\n}\n\n.modal-content .form-group input::placeholder {\n  color: rgba(226, 232, 240, 0.4);\n}\n\n.modal-content .form-group input:focus {\n  outline: none;\n  border-color: var(--primary-light);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);\n  background: rgba(15, 23, 42, 0.8);\n}\n\n.modal-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n}\n\n/* ============ LIGHT THEME OVERRIDES ============ */\n[data-theme=\"light\"] .add-user-form h2 {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .form-row input {\n  background: rgba(255, 255, 255, 0.9);\n  color: #1e293b;\n  border: 1px solid rgba(15, 23, 42, 0.15);\n}\n\n[data-theme=\"light\"] .form-row input::placeholder {\n  color: rgba(30, 41, 59, 0.4);\n}\n\n[data-theme=\"light\"] .form-row input:focus {\n  background: rgba(255, 255, 255, 1);\n  box-shadow: 0 0 0 3px rgba(100, 116, 139, 0.2);\n}\n\n[data-theme=\"light\"] .permissions-grid h4 {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .checkbox-label {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .permission-checkbox {\n  background: rgba(15, 23, 42, 0.03);\n  border: 1px solid rgba(15, 23, 42, 0.08);\n}\n\n[data-theme=\"light\"] .permission-checkbox:hover:not(.disabled) {\n  background: rgba(100, 116, 139, 0.1);\n  border-color: rgba(100, 116, 139, 0.3);\n}\n\n[data-theme=\"light\"] .user-card {\n  background: rgba(255, 255, 255, 0.9);\n  border: 1px solid rgba(15, 23, 42, 0.1);\n}\n\n[data-theme=\"light\"] .user-card:hover {\n  box-shadow: 0 20px 60px rgba(100, 116, 139, 0.15);\n  border-color: rgba(100, 116, 139, 0.3);\n}\n\n[data-theme=\"light\"] .user-header {\n  border-bottom: 1px solid rgba(15, 23, 42, 0.1);\n}\n\n[data-theme=\"light\"] .user-info h3 {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .btn-secondary {\n  background: rgba(100, 116, 139, 0.08);\n  color: #1e293b;\n  border: 1px solid rgba(100, 116, 139, 0.2);\n}\n\n[data-theme=\"light\"] .btn-secondary:hover {\n  background: rgba(100, 116, 139, 0.12);\n  border-color: rgba(100, 116, 139, 0.3);\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .no-users {\n  color: #475569;\n}\n\n[data-theme=\"light\"] .loading {\n  color: #475569;\n}\n\n[data-theme=\"light\"] .modal-content {\n  background: rgba(255, 255, 255, 0.98);\n  border: 1px solid rgba(15, 23, 42, 0.15);\n}\n\n[data-theme=\"light\"] .modal-content h2 {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .modal-content p {\n  color: #475569;\n}\n\n[data-theme=\"light\"] .modal-content .form-group label {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .modal-content .form-group input {\n  background: rgba(255, 255, 255, 0.9);\n  color: #1e293b;\n  border: 1px solid rgba(15, 23, 42, 0.15);\n}\n\n[data-theme=\"light\"] .modal-content .form-group input::placeholder {\n  color: rgba(30, 41, 59, 0.4);\n}\n\n[data-theme=\"light\"] .modal-content .form-group input:focus {\n  background: rgba(255, 255, 255, 1);\n  box-shadow: 0 0 0 3px rgba(100, 116, 139, 0.2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
